import { computed as n, unref as e, shallowRef as y, ref as b, watch as d, onBeforeUnmount as w } from "vue";
import { createPopper as S } from "./index666.js";
import f from "./index699.js";
const P = (o, i, u = {}) => {
  const p = {
    name: "updateState",
    enabled: !0,
    phase: "write",
    fn: ({ state: t }) => {
      const a = U(t);
      Object.assign(l.value, a);
    },
    requires: ["computeStyles"]
  }, s = n(() => {
    const { onFirstUpdate: t, placement: a, strategy: m, modifiers: v } = e(u);
    return {
      onFirstUpdate: t,
      placement: a || "bottom",
      strategy: m || "absolute",
      modifiers: [
        ...v || [],
        p,
        { name: "applyStyles", enabled: !1 }
      ]
    };
  }), r = y(), l = b({
    styles: {
      popper: {
        position: e(s).strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), c = () => {
    r.value && (r.value.destroy(), r.value = void 0);
  };
  return d(
    s,
    (t) => {
      const a = e(r);
      a && a.setOptions(t);
    },
    {
      deep: !0
    }
  ), d(
    [o, i],
    ([t, a]) => {
      c(), !(!t || !a) && (r.value = S(
        t,
        a,
        e(s)
      ));
    }
  ), w(() => {
    c();
  }), {
    state: n(() => {
      var t;
      return { ...((t = e(r)) == null ? void 0 : t.state) || {} };
    }),
    styles: n(() => e(l).styles),
    attributes: n(() => e(l).attributes),
    update: () => {
      var t;
      return (t = e(r)) == null ? void 0 : t.update();
    },
    forceUpdate: () => {
      var t;
      return (t = e(r)) == null ? void 0 : t.forceUpdate();
    },
    // Preventing end users from modifying the instance.
    instanceRef: n(() => e(r))
  };
};
function U(o) {
  const i = Object.keys(o.elements), u = f(
    i.map(
      (s) => [s, o.styles[s] || {}]
    )
  ), p = f(
    i.map(
      (s) => [s, o.attributes[s]]
    )
  );
  return {
    styles: u,
    attributes: p
  };
}
export {
  P as usePopper
};
